const handleResponseConversionToText = async (response: Response) => {
    if (response.ok && !(response.status >= 400)) {
        return await response.text();
    } else if (response.status >= 400) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message ?? errorResponse.detail);
    } else {
        throw new Error('Something went wrong!');
    }
};

const handleResponseConversionToJSON = async (response: Response) => {
    if (response.ok && !(response.status >= 400)) {
        const data = await response.text();
        return data.length === 0 ? null : JSON.parse(data);
    } else if (response.status >= 400) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message ?? errorResponse.detail);
    } else {
        throw new Error('Something went wrong!');
    }
};

const handleResponseConversionToBlob = async (response: Response) => {
    if (response.ok && !(response.status >= 400)) {
        return response.blob();
    } else if (response.status >= 400) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message ?? errorResponse.detail);
    } else {
        throw new Error('Something went wrong!');
    }
};

export {
    handleResponseConversionToText,
    handleResponseConversionToJSON,
    handleResponseConversionToBlob,
};
